import React, { useEffect, useState } from "react";
import { Card, Form, Row, Col, Container } from "react-bootstrap";
import DatePicker from "react-multi-date-picker";
import "react-multi-date-picker/styles/colors/teal.css"; // Optional styling
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { API_URL } from "../../../Constant.js";
import ClientNavbar from "../../Client/ClientLayout/ClientNavbar.js";
import ClientFooter from "../../Client/ClientLayout/ClientFooter.js";

const CancerDetails = () => {
  const [loginId, setLoginId] = useState(localStorage.getItem("loginId"));
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [cancerTypes, setCancerTypes] = useState([]);
  const [cancers, setcancers] = useState([]);
  const [filteredCancers, setfilteredCancers] = useState([]);
  const [selectedCancerType, setSelectedCancerType] = useState("");
  const [selectedCancer, setSelectedCancer] = useState("");
  const [phases, setPhases] = useState([]);
  const [selectedPhase, setSelectedPhase] = useState("");
  const [selectedTreatment, setSelectedTreatment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedchk, setSelectedchk] = useState(null);
  const [cancerStages, setCancerStages] = useState([]);
  const [selectedCancerStage, setSelectedCancerStage] = useState(null);
  const [grades, setGrades] = useState([]);
  const [selectedGrade, setSelectedGrade] = useState(null);
  const detectedDate = new Date(selectedYear);
  const navigate = useNavigate();

  const handleChange = (index) => {
    setSelectedchk(selectedchk === index ? null : index); // Toggle selection
  };
  const fetchCancerTypes = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetCancerTypeList");
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      console.log("Fetched Cancer Types:", data);

      if (data && Array.isArray(data.data)) {
        setCancerTypes(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setCancerTypes([]);
      }
    } catch (error) {
      console.error("Error fetching Cancer Types:", error);
      setCancerTypes([]);
    }
  };
  const fetchcancers = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetCancerList");
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      console.log("Fetched Cancers", data);

      if (data && Array.isArray(data.data)) {
        setcancers(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setcancers([]);
      }
    } catch (error) {
      console.error("Error fetching Cancer Stages:", error);
      setcancers([]);
    }
  };
  const handleCancerTypeChange = (event) => {
    const selectedId = event.target.value;
    setSelectedCancerType(selectedId);

    // Filter stages based on selected cancer type
    if (selectedId) {
      const filtered = cancers.filter(
        (stage) => stage.cancerTypeId === parseInt(selectedId)
      );
      setfilteredCancers(filtered);
    } else {
      setfilteredCancers([]);
    }
  };
  const fetchCancerPhases = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetCancerPhasesList");
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      console.log("Fetched Cancer Phases:", data);

      if (data && Array.isArray(data.data)) {
        setPhases(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setPhases([]);
      }
    } catch (error) {
      console.error("Error fetching Cancer Phases:", error);
    }
  };
  const fetchCancerStages = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetCancerStages");
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      console.log("Fetched Cancer Stages:", data);

      if (data && Array.isArray(data.data)) {
        setCancerStages(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setCancerStages([]);
      }
    } catch (error) {
      console.error("Error fetching Cancer Stages:", error);
    }
  };
  const fetchGrades = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetCancerGrades");
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      console.log("Fetched Cancer Grades:", data);

      if (data && Array.isArray(data.data)) {
        setGrades(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setGrades([]);
      }
    } catch (error) {
      console.error("Error fetching Cancer Grades:", error);
    }
  };
  const handleSaveAndNext = async (e) => {
    e.preventDefault();
    const diagnosisTypeOptions = ["First Time", "Relapse", "Recurrence"];
    console.log("Cancer Type:", selectedCancerType);
    console.log("Cancer:", selectedCancer);
    console.log("Phase:", selectedPhase);
    console.log("SubPhase (Treatment):", selectedTreatment);
    console.log(
      "Diagnosis Type:",
      selectedchk !== null ? diagnosisTypeOptions[selectedchk] : "Not selected"
    );
    console.log("Cancer Stage:", selectedCancerStage);
    console.log("Cancer Grade:", selectedGrade);

    //alert(selectedMonth);
    // Format date as MM:YYYY

    const monthNameToNumber = {
      January: "01",
      February: "02",
      March: "03",
      April: "04",
      May: "05",
      June: "06",
      July: "07",
      August: "08",
      September: "09",
      October: "10",
      November: "11",
      December: "12",
    };
    const monthh = monthNameToNumber[selectedMonth];
    //setSelectedMonth (String(detectedDate.getMonth() + 1)); // Ensure two-digit month
    alert(monthh);
    const selectedYear = detectedDate.getFullYear();
    const formattedDate = `${monthh}:${selectedYear}`;

    const cancerDetails = {
      loginId: loginId,
      isDisclaimer: true,
      cancerTypeId: parseInt(selectedCancerType, 10),
      cancerId: parseInt(selectedCancer, 10),
      cancerDetectedDate: formattedDate, // Updated date format
      cancerDiagnosisType: diagnosisTypeOptions[selectedchk],
      cancerPhaseId: parseInt(selectedPhase, 10),
      cancerSubPhaseId: parseInt(selectedTreatment, 10),
      cancerStagesId: parseInt(selectedCancerStage, 10),
      cancerGradesId: parseInt(selectedGrade, 10),
    };

    // Log final payload with Month:Year format
    console.log("Final Payload:", JSON.stringify(cancerDetails, null, 2));

    try {
      setIsSubmitting(true);
      const response = await fetch(
        API_URL + "api/Client/SaveCancerInfoDetails",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(cancerDetails),
        }
      );
      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);
      const result = await response.json();
      alert("Data saved successfully!");
      console.log("Response:", result);
      navigate("/client/PsychologicalInformation");
    } catch (error) {
      console.error("Error saving cancer details:", error);
      alert("Failed to save data. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    fetchCancerTypes();
    fetchcancers();
    fetchCancerPhases();
    fetchCancerStages();
    fetchGrades();
  }, []);

  return (
    <div style={{ paddingBottom: "30px" }}>
      <ToastContainer />
      <ClientNavbar />
      <Container className="d-flex justify-content-center mt-4">
        <Card
          className="shadow p-4"
          style={{ maxWidth: "700px", width: "100%" }}
        >
          <Card.Body>
            <h2 className="text-center">Cancer Details</h2>
            <hr />
            <Form onSubmit={handleSaveAndNext}>
              <Form.Group>
                <Row className="justify-content-center">
                  <Col xs={12} className="text-left">
                    <Form.Check type="checkbox" className="mt-2" />
                    <small>
                      <b>Disclaimer :</b> Your information will be confidential
                      and will not be used for any other purposes. And it’s
                      recommended that you submit the information because this
                      will help you to identifying the right counselor. However
                      if you not interested to share your information, you can
                      skip.
                    </small>
                  </Col>
                </Row>
              </Form.Group>
              <br />
              <Form.Group className="mb-3">
                <Row className="justify-content-center">
                  <Col xs={12} sm={8}>
                    <Form.Label>
                      <b>Cancer Type</b>
                    </Form.Label>
                    <Form.Select
                      className="form-control"
                      onChange={handleCancerTypeChange}
                    >
                      <option value="">Select Cancer Type</option>
                      {cancerTypes.map((type) => (
                        <option
                          key={type.cancerTypeId}
                          value={type.cancerTypeId}
                        >
                          {type.cancerType}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Row className="justify-content-center">
                  <Col xs={12} sm={8}>
                    <b>
                      <Form.Label>Cancer</Form.Label>
                    </b>
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedCancer(value);
                      }}
                    >
                      <option value="">Select Cancer</option>
                      {filteredCancers.map((cancer) => (
                        <option key={cancer.cancerId} value={cancer.cancerId}>
                          {cancer.cancer}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Row className="justify-content-center">
                  <Col xs={12} sm={8}>
                    <Row>
                      <Col xs={6}>
                        <b>
                          <Form.Label>Cancer Detected</Form.Label>
                        </b>
                        <br />
                        <b>
                          <Form.Label>Month</Form.Label>
                        </b>
                        <DatePicker
                          value={selectedMonth}
                          onChange={setSelectedMonth}
                          format="MMMM"
                          onlyMonthPicker
                          render={(value, openCalendar) => (
                            <Form.Control
                              type="text"
                              value={value}
                              onClick={openCalendar}
                              placeholder="Select Month"
                              style={{ width: "25vh" }}
                            />
                          )}
                        />
                      </Col>
                      <Col xs={6}>
                        <b>
                          <Form.Label style={{ marginTop: "30px" }}>
                            Year
                          </Form.Label>
                        </b>
                        <br />
                        <DatePicker
                          value={selectedYear}
                          onChange={setSelectedYear}
                          format="YYYY"
                          onlyYearPicker
                          render={(value, openCalendar) => (
                            <Form.Control
                              type="text"
                              value={value}
                              onClick={openCalendar}
                              placeholder="Select Year"
                              style={{ width: "25vh" }}
                            />
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Row className="justify-content-center">
                  <Col xs={12} sm={8}>
                    <div className="d-flex justify-content-between">
                      {["First Time", "Relapse", "Recurrence"].map(
                        (label, index) => (
                          <Form.Check
                            key={index}
                            type="checkbox"
                            label={label}
                            checked={selectedchk === index}
                            onChange={() => handleChange(index)}
                            disabled={
                              selectedchk !== null && selectedchk !== index
                            }
                          />
                        )
                      )}
                    </div>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Row className="justify-content-center">
                  <Col xs={12} sm={8}>
                    <b>
                      <Form.Label>Phases of Cancer</Form.Label>
                    </b>
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedPhase(value);
                      }}
                    >
                      <option value="">Select Phase</option>
                      {phases.map((phase) => (
                        <option
                          key={phase.cancerPhaseId}
                          value={phase.cancerPhaseId}
                        >
                          {phase.cancerPhase}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Row className="justify-content-center">
                  <Col xs={12} sm={8}>
                    <b>
                      <Form.Label>Sub-Phase of Cancer</Form.Label>
                    </b>
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedTreatment(value);
                      }}
                    >
                      <option value="">Select Treatment</option>
                      <option value="1">Chemotherapy</option>{" "}
                      <option value="2">Radiation Therapy</option>
                      <option value="3">Surgery</option>
                    </Form.Select>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Row className="justify-content-center">
                  <Col xs={12} sm={8}>
                    <b>
                      <Form.Label>Cancer Stage</Form.Label>
                    </b>
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedCancerStage(value);
                      }}
                    >
                      <option value="">Select Cancer Stage</option>
                      {cancerStages.map((stage) => (
                        <option
                          key={stage.cancerStageId}
                          value={stage.cancerStageId}
                        >
                          {stage.cancerStageName}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3">
                <Row className="justify-content-center">
                  <Col xs={12} sm={8}>
                    <b>
                      <Form.Label>Cancer Grade</Form.Label>
                    </b>
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        const value = e.target.value;
                        setSelectedGrade(value);
                      }}
                    >
                      <option value="">Select Grade</option>
                      {grades.map((grade) => (
                        <option
                          key={grade.cancerGradeId}
                          value={grade.cancerGradeId}
                        >
                          {grade.cancerGrades}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </Form.Group>
              <center>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save & Next"}
                </button>
                &nbsp;&nbsp;
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() =>
                    (window.location.href = "PsychologicalInformation")
                  }
                >
                  Skip
                </button>
              </center>
            </Form>
          </Card.Body>
        </Card>
      </Container>
      <br />
      <br />
      <ClientFooter />
    </div>
  );
};
export default CancerDetails;
